module.exports = __webpack_public_path__ + "static/media/Artboard7.3d2a6403.png";